import { DataBox, createDataBox } from 'app/common/data-box-store'
import { RecipientsInfo } from 'app/dataTypes/transfer/recipients'


export const defaultRecipientsInfo: RecipientsInfo = {
  recipientsBySenderUID: {},
  activeRecipientsBySenderUID: {},
  hasActiveRecipients: false,
}

class RecipientsInfoDataBox extends DataBox<RecipientsInfo> { }
export const recipientsInfo = createDataBox('recipientsInfo', defaultRecipientsInfo, RecipientsInfoDataBox)
